import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logos/logoCabecera.png'
import _imports_1 from '@/assets/images/logos/LOGO_FEDER.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("header", { class: "app-header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "entity-logo",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("img", {
    class: "feder-logo",
    src: _imports_1
  })
], -1)
const _hoisted_2 = { class: "app-menu" }
const _hoisted_3 = { class: "app-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RelojDisplay = _resolveComponent("RelojDisplay")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("nav", _hoisted_2, [
      _createVNode(_component_RelojDisplay, { class: "clock" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, {
            name: "fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ])
  ], 64))
}